//@flow

import {buildRoute} from '../../../http';
import {checkInvoiceStatusApi, endpoints, getOrderStockErrorsApi} from '../api';

import type {OrderStockError, OrderAction} from '../duck';

export function getOrderStockErrors({
  orderId,
  isPreOrder,
}: OrderAction): Promise<OrderStockError[] | null> {
  if (isPreOrder) return Promise.resolve(null);
  return getOrderStockErrorsApi(undefined, {
    route: buildRoute(endpoints.GET_ORDER_STOCK_ERRORS, [orderId]),
  }).toPromise();
}

export function checkInvoiceStatus({
  orderInvoiceId,
}: OrderAction): Promise<OrderStockError[] | null> {
  return checkInvoiceStatusApi(undefined, {
    route: buildRoute(endpoints.CHECK_INVOICE_STATUS, [orderInvoiceId]),
  }).toPromise();
}
